export default __webpack_public_path__ + "static/editor-ed82d93565c87b333a68d3181eb3c5f4.mp4";